// @core/api/endpoints/calendar/set_working_hours.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SetWorkingHoursRequest,
  WorkingHoursResponse,
} from '../../../types/calendar';

const BASE_PATH = '/calendar';

/**
 * Set working hours
 * Defines the current user's regular availability schedule. Used for free/busy calculations, booking links, and 'find a time' suggestions.
 */
export async function SetWorkingHours(
  data: SetWorkingHoursRequest,
  options?: RequestOptions
): Promise<WorkingHoursResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/availability/working-hours`;
  const requestOptions = options;
  return client.put<WorkingHoursResponse>(requestPath, data, requestOptions);
}
